// Ayarlar → Temsilciler listesinin filtresi (sahip, 2026-10-15): üstteki marka seçimi + arama +
// kaldırılanlar görünümü. Saf (import yok) — test/agent-filter.test.mjs esbuild'le yükler.

export interface FilterableAgent {
  name: string;
  darkCode: string;
  department: string;
  brands: string[];
  aliases: Partial<Record<string, string[]>>;
  removed: boolean;
}

/** Arama katlaması: büyük/küçük, Türkçe İ/ı ve aksanlar — "ozge" ÖZGE'yi, "aysegul" AYŞEGÜL'ü bulur. */
export function foldSearch(s: string): string {
  return String(s || '')
    .toLocaleLowerCase('tr')
    .replace(/ı/g, 'i')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
}

/**
 * Üstteki marka seçimi. Erişilebilir markaların HEPSİ seçiliyse herkes görünür — markasız
 * temsilci ve üstte seçilemeyen bir markadaki (BetBooker) temsilci dahil, yoksa hiçbir seçimde
 * görünmezlerdi. Bir alt küme seçiliyse yalnız o markalardan birinde olanlar (yalnız Hera →
 * yalnız Hera'nın temsilcileri).
 */
export function inBrandScope(agent: FilterableAgent, selected: string[], available: string[]): boolean {
  const all = available.length > 0 && available.every((b) => selected.includes(b));
  return all || agent.brands.some((b) => selected.includes(b));
}

/** Ad, DARK KOD, departman ve her markadaki alias'larda geçen metin. Boş arama herkesi tutar. */
export function matchesSearch(agent: FilterableAgent, query: string): boolean {
  const needle = foldSearch(query);
  if (!needle) return true;
  const hay = [agent.name, agent.darkCode, agent.department];
  for (const list of Object.values(agent.aliases)) if (list) hay.push(...list);
  return hay.some((h) => foldSearch(h).includes(needle));
}

export function filterAgents<T extends FilterableAgent>(
  agents: T[],
  opts: { selected: string[]; available: string[]; query: string; removed: boolean },
): T[] {
  return agents.filter(
    (a) => a.removed === opts.removed && inBrandScope(a, opts.selected, opts.available) && matchesSearch(a, opts.query),
  );
}
